import { VERTICAL_NAME } from '../shared/consts/visitor-registration-vertical';
import { apiUrlSelector } from 'store/config/selectors';
import { currentToken } from 'store/user/selectors';
import { tenantBuilding } from 'store/tenant-building/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export interface WebTrackingData {
  buildingUuid: string;
  appUuid: string;
  token: string;
  apiUrl: string;
}

export const useWebTrackingAnalytics = (): WebTrackingData | null => {
  const building = useSelector(tenantBuilding);
  const token = useSelector(currentToken);
  const currentApiUrl = useSelector(apiUrlSelector);
  return useMemo(() => {
    if (!building || !token || !currentApiUrl) {
      return null;
    }
    return {
      buildingUuid: building.uuid,
      appUuid: VERTICAL_NAME,
      token,
      apiUrl: currentApiUrl,
    };
  }, [building, token, currentApiUrl]);
};
